import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS, DEFAULT_TOUR_PROPERTY } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import TranslateButton from '../../../common/component/TranslateButton';
import { isEqual, get, cloneDeep, find } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import RedirectLink from '../../../../../models/RedirectLink';
import { Checkbox, message, Switch } from 'antd'

const CheckboxGroup = Checkbox.Group


const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false
};

class RedirectLinkDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            isSubmit: false,
            redirectLink: this.props.redirectLinkState.detail.redirectLink,
            isActive: this.props.redirectLinkState.detail.redirectLink.isActive || true
        }
    }

    componentDidMount() {
        this.initDetail()
    }
    

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getRedirectLinkDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setRedirectLinkDetail(new RedirectLink())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectLinkState.detail.redirectLink && !isEqual(nextProps.redirectLinkState.detail.redirectLink, this.props.redirectLinkState.detail.redirectLink)) {
            this.setState({ 
                redirectLink: nextProps.redirectLinkState.detail.redirectLink, 
                isActive: nextProps.redirectLinkState.detail.redirectLink.isActive,
                action: nextProps.redirectLinkState.detail.redirectLink.id ? 'UPDATE' : this.state.action 
            });
        }
    }

    render() {
        const { t } =  this.props;
        const { action, isSubmit, validation, isGetItem, redirectLink } = this.state;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="siteinfo-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'redirectlink'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.redirectLink.title')}`))
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.redirectLink.title')}`))
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            onClickBack={this.onClickBack}
                            backButtonText={t(`action.back`)}
                            onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                <HMS.FormWrapperItem>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={redirectLink.fromLink}
                                            validation={validation.fromLink}
                                            labelTitle={t(`item.redirectLink.fromLink`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`fromLink`} onChange={(e) => this.onChange('fromLink', e.target.value)}
                                                value={Func.checkUndefine(redirectLink.fromLink)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={redirectLink.toLink}
                                            validation={validation.toLink}
                                            labelTitle={t(`item.redirectLink.toLink`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`toLink`} onChange={(e) => this.onChange('toLink', e.target.value)}
                                                value={Func.checkUndefine(redirectLink.toLink)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isValidation={true}
                                            dataValidation={this.state.isActive}
                                            validation={this.state.isActive}
                                            labelTitle={t(`item.redirectLink.isActive`)}
                                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                        >
                                            <div>
                                                <Switch defaultChecked checked={this.state.isActive} onChange={this.onCheckAvailable} />
                                            </div>
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                </HMS.FormWrapperItem>
                            </Wrapper>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    onCheckAvailable = (checked) => {
        this.setState({ isActive: checked });
    }

    onChangeCheckBox = list => {
        const newData = Object.assign(this.state.redirectLink, { types: list })
        this.setState({ redirectLink: newData })
    };

    onChange = (fieldName, value) => {
        const redirectLink = this.state.redirectLink;
        redirectLink[fieldName] = value.trimLeft();
        this.setState({ redirectLink });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { t } = this.props
        const { redirectLink, action, isActive } = this.state;
        const newData = Object.assign(redirectLink, { isActive })
        if (this.validate()) {
            if(!(Func.checkWhiteListURL(newData.fromLink)) || !(Func.checkWhiteListURL(newData.toLink))) {
                message.error(t('validation.statusCode.code.REDIRECT_TO_LINK_ERROR'))
                return
            }
            if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createRedirectLinkDetail(newData)
            } else {
                this.props.updateRedirectLinkDetail(newData)
            }
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                fromLink: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.redirectLink.fromLink`)),
                toLink: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.redirectLink.toLink`)),
            }
        };
        let valueValidate = {}
        const result = Func.multipleValidate(this.state.redirectLink, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.REDIRECT_LINK.LIST.path);
        }
    }
}

export default RedirectLinkDetail;
